import { createApp } from 'vue';
import App from './App.vue';

import '@/utils/icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Vue3TouchEvents from 'vue3-touch-events';

import router from '@/router';
import i18n from '@/utils/i18n';
import clickoutside from '@/directives/clickoutside';
import * as constants from '@/utils/constants.js';
import 'animate.css';
import 'vueperslides/dist/vueperslides.css';
import '@/css/main.css';
import { createManager } from '@vue-youtube/core';
import vueVimeoPlayer from 'vue-vimeo-player';
import optimizedImageSize from '@/directives/optimizedImageSize';
import { sentryInit } from '@/utils/sentryConfig.js';
import { createPinia } from 'pinia';
import { LocalStorageKeys } from '@/enums';
import { pressAnimationPlugin } from '@/plugins/pressAnimation';

// Needed to detect if the JS was fetched correctly. Check index.html to see where it's being used.
const body = document.getElementsByTagName('body');
delete body[0].dataset.jsnotloaded;

const ytManager = createManager({
  deferLoading: {
    enabled: true,
    autoLoad: true,
  },
});
const pinia = createPinia();
const app = createApp(App);

app.directive('clickoutside', clickoutside);

app.config.productionTip = false;
app.config.devtools = import.meta.env.NODE_ENV === 'development';

sentryInit(app);

app.directive('optimized', optimizedImageSize);

app.config.globalProperties.$constants = constants.default;

app
  .use(i18n)
  .use(router)
  .use(Vue3TouchEvents)
  .use(ytManager)
  .use(vueVimeoPlayer)
  .use(pinia)
  .use(pressAnimationPlugin)
  .component('faIcon', FontAwesomeIcon);

app.mount('#app');

window.activateMatomoLogs = () => {
  localStorage.setItem(LocalStorageKeys.ActivateMatomoLogs, 'true');
};
